var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_205_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.273 8.92485C17.2707 8.96923 17.2695 9.0138 17.2695 9.05851C17.2695 9.80525 17.5989 10.5114 18.1661 10.9903C12.674 12.9926 8.74675 18.2783 8.74675 24.4765V24.483C8.74675 32.3979 15.1517 38.827 23.0455 38.827C30.9392 38.827 37.3442 32.3979 37.3442 24.483C37.3442 17.1301 32.0205 11.0304 25.1326 10.2275L24.5747 10.1624V10.7241V12.5228L19.9556 9.05851L24.5747 5.59425V7.47086V7.92193L25.0234 7.96822C33.1875 8.81059 39.5909 15.8758 39.5909 24.4789C39.5909 33.6391 32.1754 41.0738 23.0455 41.0738C13.9163 41.0738 6.50162 33.6408 6.5 24.4805L17.273 8.92485ZM17.273 8.92485C10.9851 11.2762 6.50078 17.3561 6.5 24.4789C6.5 24.4789 6.5 24.4789 6.5 24.4789V24.4804L17.273 8.92485ZM26.1912 24.9081L25.6354 24.4805L26.1912 24.053L30.6623 20.6135V28.3475L26.1912 24.9081ZM25.3864 24.2889V24.6721V25.3044V27.7273C25.3864 28.1232 25.0648 28.4448 24.6688 28.4448H16.1461C15.7502 28.4448 15.4286 28.1232 15.4286 27.7273V21.2338C15.4286 20.8378 15.7502 20.5163 16.1461 20.5163H24.6688C25.0648 20.5163 25.3864 20.8378 25.3864 21.2338V23.6567V24.2889Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_205_26",
    x: 0,
    y: 0,
    width: 46.0909,
    height: 48.5738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.184314 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_205_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_205_26",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateblue);
export default __webpack_public_path__ + "static/media/rotateblue.38bdc44a64b4c02e19d96cc85441c4db.svg";
export { ForwardRef as ReactComponent };